import cx from 'classnames';

import { Summary } from './Summary';
import styles from './Summary.css';

const SummaryPlugin = ({ className, SUMMARY_TAG, ...attributes } = {}) => ({
  renderElement: Summary({
    className: cx(styles.summary, className),
    SUMMARY_TAG,
    ...attributes,
  }),
});

export { SummaryPlugin };
